const loadLazyMotionVideo = (video, shouldPlay = false) => {
  if (video.dataset.videoLoaded !== 'true') {
    video.src = video.dataset.videoSrc;
    video.dataset.videoLoaded = 'true';
    video.load();
  }

  if (shouldPlay) video.play().catch(() => {});
};

const initializeLazyMotionVideos = (root = document) => {
  const videos = root.querySelectorAll('[data-lazy-motion-video]');
  if (!videos.length) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => loadLazyMotionVideo(video));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        loadLazyMotionVideo(video, video.dataset.userPaused !== 'true');
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { rootMargin: '250px 0px', threshold: 0.01 });

  videos.forEach((video) => {
    if (video.dataset.lazyVideoReady === 'true') return;
    video.dataset.lazyVideoReady = 'true';
    observer.observe(video);
  });
};

const initializeLaunchAccessibility = (root = document) => {
  initializeLazyMotionVideos(root);

  root.querySelectorAll('.luv-proof-rail__card[aria-label]').forEach((card) => {
    const visibleParts = [
      card.querySelector('.luv-proof-rail__stars')?.getAttribute('aria-label'),
      card.querySelector('.luv-proof-rail__source, .luv-proof-rail__verified')?.textContent,
      card.querySelector('.luv-proof-rail__quote')?.textContent,
      card.querySelector('.luv-proof-rail__name')?.textContent,
      card.querySelector('.luv-proof-rail__product')?.textContent,
    ].filter(Boolean).map((part) => part.trim());

    card.setAttribute('aria-label', visibleParts.join('. '));
  });

  root.querySelectorAll('.velvo-motion-control').forEach((button) => {
    if (button.dataset.accessibilityReady === 'true') return;

    const video = button.parentElement?.querySelector('video');
    const label = button.querySelector('[data-velvo-motion-label]');
    if (!video || !label) return;

    button.dataset.accessibilityReady = 'true';

    const updateLabel = () => {
      label.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.dataset.userPaused = 'false';
        loadLazyMotionVideo(video, true);
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
      }
    });

    video.addEventListener('play', updateLabel);
    video.addEventListener('pause', updateLabel);
    updateLabel();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeLaunchAccessibility());
} else {
  initializeLaunchAccessibility();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeLaunchAccessibility(event.target);
});
